import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { Link, NavLink } from "react-router-dom";

// reactstrap components
import {
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Button,
  ButtonGroup,
  UncontrolledTooltip,
} from "reactstrap";

import * as actions from "../../store/actions/index";

const MyActivities = (props) => {
  useEffect(() => {
    props.onGetActivities(props.user.userId);
  }, []);

  return (
    <>
      <Col md="12">
        {props.userActivities.length === 0 ? null : (
          <h4>
            <small>My Events</small>
          </h4>
        )}
      </Col>
      <Col md="12">
        <Card className="card-plain">
          <CardBody>
            <Table className="table-shopping" responsive>
              {props.userActivities.length === 0 ? null : (
                <thead>
                  <tr>
                    <th className="text-center"></th>
                    <th>Event</th>
                    <th className="text-right">Distance</th>
                    <th className="text-right">Time</th>
                    <th className="text-center"></th>
                  </tr>
                </thead>
              )}
              <tbody>
                {props.userActivities.length === 0
                  ? null
                  : props.userActivities.map((item) => (
                      <tr key={item.data.id}>
                        <td>
                          <div className="img-container">
                            <img alt="..." src={item.data.eventFlyer}></img>
                          </div>
                        </td>
                        <td className="td-name">{item.data.eventName}</td>
                        <td className="td-number">
                          {item.data.distance}
                          <small>KM</small>
                        </td>
                        <td className="td-number">{item.data.time}</td>
                        <td>
                          <span style={{ color: "gold", fontSize: "2em" }}>
                            <i class="fas fa-medal"></i>
                          </span>
                        </td>
                      </tr>
                    ))}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    athlete: state.strava.athlete,
    profileImage: state.strava.profileImage,
    firstName: state.strava.firstName,
    lastName: state.strava.lastName,
    city: state.strava.city,
    activities: state.strava.activities,
    authenticated: state.authentication.authenticated,
    userActivities: state.activities.userActivities,
    user: state.authentication.user,
    event: state.event.events,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetStravaAuthCode: (authCode, refresh_token, tokenExpired) =>
      dispatch(
        actions.getStravaAuthCode(authCode, refresh_token, tokenExpired)
      ),
    onGetStravaActivities: (access_token) =>
      dispatch(actions.getStravaActivities(access_token)),
    onGetStravaAthlete: (access_token) =>
      dispatch(actions.getStravaAthlete(access_token)),
    onGetActivities: (userId) => dispatch(actions.getActivities(userId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyActivities);
